import { Link } from "@tanstack/react-router";
import FeatherIcon from "feather-icons-react";
import { useLayoutStore } from "layout/store";
import style from "./style.module.scss";

export function MenuItemLink({
	url,
	params,
	search,
	title,
	icon,
}: {
	url: string;
	// biome-ignore lint/suspicious/noExplicitAny: TODO
	params?: Record<string, any>;
	// biome-ignore lint/suspicious/noExplicitAny: TODO
	search?: Record<string, any>;
	title: string;
	icon: string | undefined;
}) {
	const menuMobile = useLayoutStore((s) => s.menuMobile);

	return (
		<Link
			to={url}
			params={params}
			search={search}
			onClick={() => {
				if (menuMobile) {
					setTimeout(() => {
						useLayoutStore.setState({ menuOpen: false });
					}, 200);
				}
			}}
		>
			<span className={style.title}>{title}</span>
			{icon && (
				<span>
					<FeatherIcon icon={icon} className={`${style.icon} icon-collapsed-hidden`} />
				</span>
			)}
		</Link>
	);
}
